import ResourceAdmin from "./ResourceAdmin";

export const AdminPlayers = () => (
    <ResourceAdmin
        title="Players"
        resource="players"
        listKey="name"
        imageField="photo_url"
        emptyValues={{ is_published: true, sort_order: 0, games_played: 0, ppg: 0, rpg: 0, apg: 0, spg: 0, bpg: 0, fg_pct: 0, three_pct: 0, ft_pct: 0 }}
        fields={[
            { key: "name", label: "Name" },
            { key: "jersey_number", label: "Jersey #" },
            { key: "position", label: "Position" },
            { key: "height", label: "Height" },
            { key: "age", label: "Age", type: "number" },
            { key: "hometown", label: "Hometown" },
            { key: "bio", label: "Bio", type: "textarea" },
            { key: "photo_url", label: "Photo", type: "image" },
            { key: "games_played", label: "Games Played", type: "number" },
            { key: "ppg", label: "Points / Game", type: "number" },
            { key: "rpg", label: "Rebounds / Game", type: "number" },
            { key: "apg", label: "Assists / Game", type: "number" },
            { key: "spg", label: "Steals / Game", type: "number" },
            { key: "bpg", label: "Blocks / Game", type: "number" },
            { key: "fg_pct", label: "FG % (e.g. 47.2)", type: "number" },
            { key: "three_pct", label: "3PT % (e.g. 38.6)", type: "number" },
            { key: "ft_pct", label: "FT % (e.g. 84.1)", type: "number" },
            { key: "sort_order", label: "Sort Order", type: "number" },
            { key: "is_published", label: "Published", type: "boolean", help: "Visible on site" },
        ]}
    />
);

export const AdminCoaches = () => (
    <ResourceAdmin
        title="Coaches & Staff"
        resource="coaches"
        listKey="name"
        imageField="photo_url"
        emptyValues={{ is_published: true, sort_order: 0 }}
        fields={[
            { key: "name", label: "Name" },
            { key: "title", label: "Title" },
            { key: "bio", label: "Bio", type: "textarea" },
            { key: "photo_url", label: "Photo", type: "image" },
            { key: "sort_order", label: "Sort Order", type: "number" },
            { key: "is_published", label: "Published", type: "boolean" },
        ]}
    />
);

export const AdminGames = () => (
    <ResourceAdmin
        title="Schedule"
        resource="games"
        listKey="opponent"
        emptyValues={{ home_away: "home", status: "scheduled" }}
        fields={[
            { key: "opponent", label: "Opponent" },
            { key: "date", label: "Date / Time (ISO)", help: "e.g. 2026-04-12T19:30:00Z" },
            { key: "location", label: "Location" },
            { key: "home_away", label: "Home/Away", type: "select", options: ["home", "away"] },
            { key: "status", label: "Status", type: "select", options: ["scheduled", "live", "final"] },
            { key: "result", label: "Result (e.g. W 102-88)" },
            { key: "our_score", label: "Our Score", type: "number" },
            { key: "opp_score", label: "Opponent Score", type: "number" },
            { key: "notes", label: "Notes", type: "textarea" },
        ]}
    />
);

export const AdminNews = () => (
    <ResourceAdmin
        title="News Articles"
        resource="news"
        listKey="title"
        imageField="cover_image"
        emptyValues={{ is_published: true, author: "Purple Kings Staff" }}
        fields={[
            { key: "title", label: "Title" },
            { key: "slug", label: "Slug (URL friendly)", help: "lowercase-dashes" },
            { key: "excerpt", label: "Excerpt", type: "textarea", rows: 2 },
            { key: "body", label: "Body (HTML allowed)", type: "textarea", rows: 10 },
            { key: "cover_image", label: "Cover Image", type: "image" },
            { key: "author", label: "Author" },
            { key: "is_published", label: "Published", type: "boolean" },
        ]}
    />
);

export const AdminSponsors = () => (
    <ResourceAdmin
        title="Sponsors & Partners"
        resource="sponsors"
        listKey="name"
        imageField="logo_url"
        emptyValues={{ tier: "partner", is_published: true }}
        fields={[
            { key: "name", label: "Name" },
            { key: "tier", label: "Tier", type: "select", options: ["platinum", "gold", "partner"] },
            { key: "logo_url", label: "Logo", type: "image" },
            { key: "website", label: "Website URL" },
            { key: "sort_order", label: "Sort Order", type: "number" },
            { key: "is_published", label: "Published", type: "boolean" },
        ]}
    />
);

export const AdminGallery = () => (
    <ResourceAdmin
        title="Gallery"
        resource="gallery"
        listKey="title"
        imageField="image_url"
        emptyValues={{ is_published: true }}
        fields={[
            { key: "title", label: "Title (Optional)" },
            { key: "image_url", label: "Image", type: "image" },
            { key: "caption", label: "Caption" },
            { key: "sort_order", label: "Sort Order", type: "number" },
            { key: "is_published", label: "Published", type: "boolean" },
        ]}
    />
);
